import React, { useRef, useEffect, useState, memo, useMemo } from "react";
import { FlatList, StyleSheet, TouchableOpacity, Text, View, useWindowDimensions, Animated, ScrollView } from "react-native";
import CustomPressable from "../../components/customPressable/customPressable";
import { ImageComp } from "../../components/Image/Image";
// import { PLUS } from "../../assets";
import CustomFlatList from "../../components/customFlatList";
import { CHEVRON_RIGHT, MINUS, PLUS } from "../../assets";
import { useCssStyle } from "../../customHook/getCssStyle";
import { getCleanUrl } from "../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import { HCOMMERCE } from "../../config/Constant";
import RenderHTML from "react-native-render-html";

export const StoreLevel2 = memo((props) => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();

    const { storeData, selectedStoreItemSubType, handleStoreItemSubTypeSelect, cartItem, handleAddToCart, handleRemoveFromCart, handleItemInfo } = props || {};
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const customWidgetHeaderTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_storelevel2_HeaderTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetHeaderSubTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_storelevel2_HeaderSubTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_itemContainer_textContainer_title']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetSubTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_storelevel2_itemContainer_textContainer_subtitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Animated value for sliding in the + and - buttons
    const slideAnim = useRef(new Animated.Value(0)).current;  // Start hidden

    // Trigger animation when quantity is greater than 0
    const animateSlideIn = () => {
        Animated.timing(slideAnim, {
            toValue: 1, // Fully visible
            duration: 300,
            useNativeDriver: true,
        }).start();
    };

    useEffect(() => {

        animateSlideIn();
        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 2", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken, subStoreName: selectedStoreItemSubType.subTypeName, subStoreSku: selectedStoreItemSubType.sku }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (

        <View style={getStyles(['widgetmainContainer', 'hcommerce_storelevel2_MainContainer'])} id="widgetmainContainer hcommerce_storelevel2_MainContainer">

            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_storelevel2_HeaderImg'])} id={`widgetmainContainerHeaderImg hcommerce_storelevel2_HeaderImg`} />
            }
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_storelevel2_HeaderContainer'])} id="widgetmainContainerHeaderContainer hcommerce_storelevel2_HeaderContainer">
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_storelevel2_HeaderTitleContainer'])} id="widgetmainContainerHeaderTitleContainer hcommerce_storelevel2_HeaderTitleContainer">
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeName}}
                            systemFonts={[customWidgetHeaderTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderTitle hcommerce_storelevel2_HeaderTitle`}
                        />
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderSubTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeDescription}}
                            systemFonts={[customWidgetHeaderSubTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderSubTitle hcommerce_storelevel2_HeaderSubTitle`}
                        />
                    </View>
                </View>

                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainerChildContainer', 'hcommerce_storelevel2_MainContainerChildContainer'])} id="widgetmainContainerChildContainer hcommerce_storelevel2_MainContainerChildContainer">

                    <View style={getStyles(['hcommerce_storelevel2_ChildContainer_items_container'])} id="hcommerce_storelevel2_ChildContainer_items_container">
                        {
                            storeData.storeItemSubTypeInfo.map((storeItemSubTypeInfo) => {
                                if (selectedStoreItemSubType.storeItemSubTypeID.includes(storeItemSubTypeInfo.id)) {

                                    const imageUri = storeItemSubTypeInfo.storeItemTypeImages?.find(image => image.imageType === "LARGE")?.imagePath || storeItemSubTypeInfo.storeItemTypeImages[0]?.imagePath;

                                    return (
                                        <CustomPressable key={storeItemSubTypeInfo.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_itemContainer'])} onPress={() => handleStoreItemSubTypeSelect(storeItemSubTypeInfo)} id={`list_itemContainer hcommerce_storelevel2_itemContainer ${storeItemSubTypeInfo.id}`}>

                                            <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel2_itemContainer_image">
                                                {imageUri &&
                                                    <ImageComp
                                                        source={getCleanUrl(imageUri)}
                                                        style={getStyles(["hcommerce_storelevel2_item_image", { width: "100%", height: "100%" }])}
                                                        id="hcommerce_storelevel2_item_image"
                                                    />
                                                }
                                            </View>
                                            <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel2_itemContainer_textContainer">
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetTitleStyle}
                                                    source={{ html: storeItemSubTypeInfo.subTypeName}}
                                                    systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title_${storeItemSubTypeInfo.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                                {storeItemSubTypeInfo.subTypeDescription &&
                                                    <RenderHTML
                                                        contentWidth={width}
                                                        baseStyle={customWidgetSubTitleStyle}
                                                        source={{ html: storeItemSubTypeInfo.subTypeDescription}}
                                                        systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                        id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_itemContainer_textContainer_subtitle_${storeItemSubTypeInfo.id}`}
                                                        defaultTextProps={{
                                                            numberOfLines: 1
                                                        }}
                                                    />
                                                }
                                            </View>

                                            <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_storelevel2_itemContainer_arrow'])} id="list_itemContainer_arrow hcommerce_storelevel2_itemContainer_arrow">
                                                <ImageComp source={CHEVRON_RIGHT} />
                                            </View>
                                        </CustomPressable>
                                    )
                                }
                                return null;
                            })
                        }
                    </View>


                    <View style={getStyles(['hcommerce_storelevel2_ChildContainer_items_container'])} id="hcommerce_storelevel2_ChildContainer_items_container">
                        {
                            storeData.storeItemInfo.map((storeItemInfo, index) => {
                                if (selectedStoreItemSubType.storeItemID.includes(storeItemInfo.id)) {

                                    const totalQuantity = cartItem.reduce((total, item) => {
                                        return item.itemInfo.id == storeItemInfo.id ? total + item.quantity : total;
                                    }, 0);

                                    const imageUri = storeItemInfo.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || storeItemInfo.storeItemImages?.[0]?.imagePath;

                                    return (
                                        <CustomPressable key={index} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_itemContainer'])} onPress={() => { handleItemInfo(storeItemInfo) }} id={`list_itemContainer hcommerce_storelevel2_itemContainer ${storeItemInfo.id}`}>

                                            <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_itemContainer_image'])} id={`list_itemContainer_image hcommerce_storelevel2_itemContainer_image ${storeItemInfo.id}`}>
                                                {imageUri &&
                                                    <ImageComp
                                                        source={getCleanUrl(imageUri)}
                                                        style={getStyles(["hcommerce_storelevel2_item_image", { width: "100%", height: "100%" }])}
                                                        id="hcommerce_storelevel2_item_image"
                                                    />
                                                }
                                            </View>
                                            <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_itemContainer_textContainer'])} id={`list_itemContainer_textContainer hcommerce_storelevel2_itemContainer_textContainer ${storeItemInfo.id}`}>
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetTitleStyle}
                                                    source={{ html: storeItemInfo.itemName}}
                                                    systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title_${storeItemInfo.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                                {storeItemInfo.itemDescription &&
                                                    <RenderHTML
                                                        contentWidth={width}
                                                        baseStyle={customWidgetSubTitleStyle}
                                                        source={{ html: storeItemInfo.itemDescription}}
                                                        systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                        id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_itemContainer_textContainer_subtitle_${storeItemInfo.id}`}
                                                        defaultTextProps={{
                                                            numberOfLines: 1
                                                        }}
                                                    />
                                                }


                                                <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_storelevel2_itemContainer_textContainer_tertiaryContainer'])} id={`list_itemContainer_textContainer_tertiaryContainer hcommerce_storelevel2_itemContainer_textContainer_tertiaryContainer ${storeItemInfo.id}`} >

                                                    <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_itemContainer_textContainer_title'])} id="list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title" >{currencyCode + storeItemInfo.itemPrice}</Text>

                                                    <View style={getStyles(['additem_controls'])} id="additem_controls" >
                                                        {totalQuantity > 0 &&
                                                            <CustomPressable onPress={() => handleRemoveFromCart(storeItemInfo)} style={getStyles(['additem_controls_sub_container'])} id={`additem_controls_sub_container`}>
                                                                <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                            </CustomPressable>
                                                        }
                                                        {totalQuantity > 0 &&
                                                            <Text style={getStyles(['additem_controls_qty_text'])} id="additem_controls_qty_text">{totalQuantity}</Text>
                                                        }
                                                        <CustomPressable onPress={() => handleAddToCart(storeItemInfo)} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                            <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                        </CustomPressable>

                                                    </View>

                                                </View>
                                            </View>
                                        </CustomPressable>
                                    )
                                }

                                return null;
                            })
                        }
                    </View>
                </ScrollView>
            </ScrollView>
        </View>
    );
});

